// http://wiki.objectvision.nl/index.php/Fisher%27s_Natural_Breaks_Classification
function targetToMax (start, stop, cumsumValues, cumsumWight) {
  return Math.pow(cumsumValues[stop] - cumsumValues[start], 2) / (cumsumWight[stop] - cumsumWight[start])
}

function naturalBreaksN (cache, cumsumValues, cumsumWight, start, number) {
  if (number === 0) {
    return {
      s: targetToMax(start, cumsumValues.length - 1, cumsumValues, cumsumWight),
      breaks: [],
    }
  }

  if (!cache[number]) {
    cache[number] = []
  }
  if (cache[number][start]) {
    return cache[number][start]
  }
  let out = {
    s: 0,
    breaks: undefined,
  }
  let last = cache[number][start - 1]
  let startAt = Math.max(start + 1, (last && last.breaks && last.breaks[0]) || 0)
  let smaller = cache[number - 1] && cache[number - 1][start]
  let stopAt = Math.min(cumsumValues.length - 1 - number, (smaller && smaller.breaks && smaller.breaks[0]) || Infinity)
  // console.log(start, number, startAt, stopAt)

  for (let i = startAt; i <= stopAt; i += 1) {
    let new_l = targetToMax(start, i, cumsumValues, cumsumWight)
    let new_r = naturalBreaksN(cache, cumsumValues, cumsumWight, i, number - 1)
    if ((new_l + new_r.s) > out.s) {
      out.s = (new_l + new_r.s)
      if (i === startAt && last && last.breaks) {
        out.breaks = last.breaks
      } else {
        out.breaks = [i].concat(new_r.breaks)
      }
    }
  }
  cache[number][start] = out
  return out
}

export function naturalBreaks (data, number, wights) {
  if (number < 1) {
    return 'number must be grater then or equal to one'
  }
  wights = wights || []
  let sorted = data.map((d, i) => {
    return { data: d, wight: wights[i] || 1 }
  })
  sorted.sort((a, b) => a.data - b.data)
  let cumsumValues = [0].concat(sorted.map((sum => value => sum += (value.data * value.wight))(0)))
  let cumsumWight = [0].concat(sorted.map((sum => value => sum += value.wight)(0)))
  let out = naturalBreaksN([], cumsumValues, cumsumWight, 0, number)
  return out.breaks.map(i => (sorted[i - 1].data + sorted[i].data) / 2)
}

export function naturalBreaksWithPivot (data, number, pivot, wights) {
  if (number < 2) {
    return 'number must be grater then or equal to two'
  }
  wights = wights || []
  let sorted = data.map((d, i) => {
    return { data: d, wight: wights[i] || 1 }
  })
  sorted.sort((a, b) => a.data - b.data)
  let pivotIndex = sorted.findIndex(x => x.data >= pivot)
  let smaller = sorted.slice(0, pivotIndex)
  let larger = sorted.slice(pivotIndex)
  let smallerCumsumValues = [0].concat(smaller.map((sum => value => sum += (value.data * value.wight))(0)))
  let smallerCumsumWight = [0].concat(smaller.map((sum => value => sum += value.wight)(0)))
  let largerCumsumValues = [0].concat(larger.map((sum => value => sum += (value.data * value.wight))(0)))
  let largerCumsumWight = [0].concat(larger.map((sum => value => sum += value.wight)(0)))
  let smallerCache = []
  let largerCache = []
  let out = {
    s: 0,
    breaks: undefined,
  }
  for (let numberInSmaller = 0; numberInSmaller < number; numberInSmaller += 1) {
    let newSmallerBreaks = naturalBreaksN(smallerCache, smallerCumsumValues, smallerCumsumWight, 0, numberInSmaller)
    let newLargerBreaks = naturalBreaksN(largerCache, largerCumsumValues, largerCumsumWight, 0, number - 1 - numberInSmaller)
    if ((newSmallerBreaks.s + newLargerBreaks.s) > out.s) {
      out.s = (newSmallerBreaks.s + newLargerBreaks.s)
      out.breaks = [].concat(
        (newSmallerBreaks.breaks || []).map(i => (smaller[i - 1].data + smaller[i].data) / 2),
        [pivot],
        (newLargerBreaks.breaks || []).map(i => (larger[i - 1].data + larger[i].data) / 2),
      )
    }

  }
  return out.breaks
}
